function openNav() {
  document.getElementById("mySidebar").style.width = "250px";
  document.getElementById("main_mobile_slider").style.marginRight = "250px";
}

function closeNav() {
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("main_mobile_slider").style.marginRight = "0";
}